import {
  AggregationBindingInfo,
  PropertyBindingInfo,
} from "sap/ui/base/ManagedObject";
import Binding from "sap/ui/model/Binding";
import Filter from "sap/ui/model/Filter";
import FilterOperator from "sap/ui/model/FilterOperator";

export function FilterBinding(
  filterValue: string | undefined,
  binding: Binding | undefined,
  filterPaths: string[]
) {
  filterValue = filterValue?.toLowerCase();
  filterPaths = filterPaths.filter((p) => p); // remove empty paths
  let aFilters: Filter[] = [];

  if (filterValue && filterPaths.length > 0) {
    const internalFilters: Filter[] = [];
    for (let filterPath of filterPaths) {
      internalFilters.push(
        new Filter({
          path: filterPath,
          operator: FilterOperator.Contains,
          value1: filterValue,
        })
      );
    }
    aFilters.push(
      new Filter({
        and: false, // OR is applied
        filters: internalFilters,
      })
    );
  }

  // @ts-expect-error Method "filter" exists, but isn't exposed through the type
  binding?.filter(aFilters);
}

export function GetInfoFromBindingTemplate(
  bindingInfo: AggregationBindingInfo,
  value: string
) {
  const valueProp = bindingInfo?.template?.getBindingInfo(
    value
  ) as PropertyBindingInfo;
  return valueProp;
}

export function GetValueForBindingInfo(prop: PropertyBindingInfo) {
  return prop?.parts
    ? typeof prop?.parts[0] === "string"
      ? prop?.parts[0]
      : prop?.parts[0].path
    : (prop?.path ?? "");
}
